import { Table, Text, Group, Paper, Title, Notification, Loader } from '@mantine/core';
import { ICurrencyRates, IWithdrawal } from '../types';
import React, { useEffect, useState } from 'react';
import { makeGetRequest } from '../services/httpHelper';
import { convertCurrency, isErrorObject } from '../utils/utils';
import ErrorHandler from '../services/ErrorHandler';
import { IconAlertCircle } from '@tabler/icons-react';

type transProps = {
    withdrawals: IWithdrawal[];
    campaign_currency:string
   
};

const CampaignWithdrawalStatement: React.FC<transProps> = ({ withdrawals,campaign_currency }) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [exchangeRates, setExchangeRates] = useState<ICurrencyRates>();


    // Fetch exchange rates
    const fetchExchangeRates = async () => {
        const endpoint = "latest-currency-exchange-rates";
        setIsLoading(true);
        const res = await makeGetRequest(endpoint);
        if (isErrorObject(res)) {
            setError(ErrorHandler(res));
        } else {
            setExchangeRates(res.data);
            setIsLoading(false);
        }
    };

    // Currency conversion handler
    const handleCurrencyConversion = (amount: number, fromCurrency: string, toCurrency: string) => {
        return convertCurrency(amount, fromCurrency, toCurrency, exchangeRates?.rates || {});
    };



    const totalWithdrawals = withdrawals.reduce<number>((acc, d) => {
        const amount = handleCurrencyConversion(Number(d.amount || 0), d.currency || campaign_currency, campaign_currency)?.amount || 0;
        return acc + amount;
      }, 0);


   


    useEffect(() => {
        fetchExchangeRates();
    }, []);

    // Table rows
    const rows = withdrawals.map((transaction: IWithdrawal, index: number) => (
        <tr key={index}>
            <td>{new Date(transaction.createdAt).toLocaleString()}</td>
            <td>{transaction.amount}</td>
            {/*<td>{transaction.currency}</td>*/}
            <td>{transaction.account_type}</td>
            <td>{transaction.mpesa_number}</td>
            <td>{transaction.bank_name}</td>
            <td>{transaction.account_name}</td>
            <td>{transaction.account_number}</td>
            <td>{transaction.initiator.first_name} {transaction.initiator.last_name}</td>
            <td>{transaction.status}</td>     
             
            
        </tr>
    ));

    return (
        <Paper withBorder radius="md" p="md">
            <Group position="apart" mb="md">
                <Title order={3}>Withdrawal Statement</Title>
                {isLoading && <Loader />}
                {error && (
                    <Notification icon={<IconAlertCircle size={18} />} color="red" mb="lg">
                        {error}
                    </Notification>
                )}
            
                  <Group spacing="xl">
                  
                    <div>
                        <Text>Total Withdrawals:</Text>
                        <Text weight={700} color="red">
                            {totalWithdrawals.toLocaleString(undefined, {
                                style: 'currency',
                                currency: campaign_currency,
                            })}
                        </Text>
                    </div>
               
                </Group>
                
            </Group>

            <Table striped highlightOnHover>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Amount({campaign_currency})</th>
                        <th>Account Type</th>
                        <th>Mobile  Number</th>
                        <th>Bank</th>
                        <th>Account Name</th>
                        <th>Account Number</th>
                        <th>Transacted By</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>{rows}</tbody>
            </Table>
        </Paper>
    );
};

export default CampaignWithdrawalStatement;
